<div class="row">
    <div class="col-xs-12">
        <form novalidate *ngIf="job">
            <div class="main-box clearfix">
                <div class="row" style="padding-bottom: 10px; margin-top: 10px;" *ngIf="job.jobBoardDetails && job.jobBoardDetails.length > 0">
                    <div class="col-xs-12 text-danger job-boards-pull-limit-warning-container" *ngIf="isTrialPlanActive">
                        <span *ngIf="jobBoardsResumePullLeft > 0" class="job-boards-pull-limit-warning">
                            You are on a Trial Plan. You can pull only <span>{{jobBoardsPullResumePulled + jobBoardsResumePullLeft}} </span> resumes from Job Boards. Currently you have pulled <span>{{jobBoardsPullResumePulled}}</span> resumes. You have <span>{{jobBoardsResumePullLeft}}</span> pulls left.
                        </span>
                        <span *ngIf="jobBoardsResumePullLeft == 0" class="job-boards-pull-limit-warning">
                           You have no free Job Board Resume Pulls Left. Please talk to you administrator to resolve the issue.
                        </span>
                    </div>
                    <div class="col-xs-12" style="padding: 15px; padding-left: 45px;">
                        <p>
                            By default, the existing candidates in the system will be available for this job
                            requisition.
                        </p>
                        <span>
                            In addition, do you also want to pull <span *ngIf="currentJobStatus === 'OPEN' && editModeFlag" class="emerald">more </span>resumes from Job Boards?
                            <div style="display:inline" [ngClass]="{'license-pref-label-disabled': !isJobIntegrationEnabledByPlan || !isJobBoardServiceUp}">
                                <div class="upload-req-radio" style="display: inline; margin-left: 75px">
                                    <input type="radio" name="useJobBoards" id="useJobBoard" [value]="true"
                                       [(ngModel)]="job.isResumePullEnabled" name="isResumePullEnabled" (ngModelChange)="onUseJobBoardChange()"
                                       [disabled]="!isJobIntegrationEnabledByPlan || !isJobBoardServiceUp">
                                    <label for="useJobBoard">
                                        Yes
                                    </label>
                                </div>
                                <div class="upload-req-radio" style="display: inline;">
                                    <input type="radio" name="useJobBoards" id="doNotUseJobBoard" [value]="false"
                                       [(ngModel)]="job.isResumePullEnabled" name="isResumePullEnabled" (ngModelChange)="onUseJobBoardChange()"
                                       [disabled]="!isJobIntegrationEnabledByPlan || !isJobBoardServiceUp">
                                    <label for="doNotUseJobBoard">
                                        No
                                    </label>
                                </div>
                            </div>
                            <div style="display:inline;" *ngIf="!isJobIntegrationEnabledByPlan">
                                ( Upgrade your plan to use this feature <span class="fa fa-2x fa-star gold" style="padding-left: 5px;"></span> )
                            </div>
                            <div style="display:inline;" *ngIf="!isJobBoardServiceUp" class="text-danger">
                                Job Board Service is currently unavailable.
                            </div>
                        </span>
                    </div>
                </div>
                <div *ngIf="job.jobBoardDetails && job.jobBoardDetails.length > 0">
                    <div class="main-box clearfix" style=" border-bottom: 0;box-shadow: 0px 0px 0px white; padding-top:20px">
                        <div class="col-xs-12">
                            <app-job-boards-supported-parameters *ngIf="showWizardSteps" [job]="job" [isEditable]="job.isResumePullEnabled" context="editRequisition"
                            (jobBoardsSelectionChange)="onJobBoardSelectionChange()" [readOnlyJobBoardsData]="jobBoardDetailsCopy" [activeFilterTab]="activeJobBoardsFilterTabNumber"
                            [radiusOptions]="radiusOptions" [recencyOptions]="recencyOptions" [resumePullOptions]="resumePullCounts" [savedResumePullCount]="resumesToPullPerJobBoardCountCopy">
                            </app-job-boards-supported-parameters>
                        </div>
                    </div>
                </div>
                <div class="main-box clearfix" *ngIf="!job.jobBoardDetails || job.jobBoardDetails.length === 0" style="border-bottom: 0;box-shadow: 0px 0px 0px white">
                    <div class="row" style="margin-top: 10px;">
                        <div class="col-xs-11 col-xs-offset-1">
                            <div class="row" style="padding-top: 15px;">
                                <div>
                                    No Job Board(s) available. Please setup the job board(s).
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
